import { Controller, useFormContext } from 'react-hook-form'
import Form from 'react-bootstrap/Form'

export interface Props {
  className?: string
  label?: string
  name: string
  value: string | number | readonly string[] | undefined
}

export const RadioButton = ({ className, label, name, value }: Props) => {
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <Form.Group className={className} controlId={`${name}_${value}`}>
          <Form.Check
            checked={field.value === value}
            isInvalid={Boolean(fieldState.error)}
            label={label}
            name={field.name}
            onBlur={field.onBlur}
            onChange={field.onChange}
            ref={field.ref}
            type="radio"
            value={value}
          />
        </Form.Group>
      )}
    />
  )
}
